export default __webpack_public_path__ + "static/media/CloseIconWhite.abf46270.svg";